import {
    ableProps,
    ablePropsInit,
    requiredProps,
    requiredPropsInit,
    validatorProps,
    validatorPropsInit,
    events as baseEvents,
} from '../component-base/props';

export const props = () => [
    ...ableProps,
    {
        key: 'placeholder',
        label: '占位文字',
        type: 'string',
    },
    {
        key: 'type',
        label: '选择器类型',
        type: 'enum',
        collection: [
            {
                label: '日期',
                value: 'date',
            },
            {
                label: '时间',
                value: 'time',
            },
            {
                label: '日期+时间',
                value: 'datetime',
            },
            {
                label: '年+月',
                value: 'year-month',
            },
        ],
    },
    {
        key: 'timeModeResetDate',
        label: '时间模式日期为1970/1/1',
        type: 'boolean',
    },
    {
        key: 'title',
        label: '标题文字',
        type: 'string',
    },
    {
        key: 'minDateOffset',
        label: '最小可选时间距离当前毫秒数',
        type: 'number',
        props: {
            controls: false,
            placeholder: '默认十年前',
        },
    },
    {
        key: 'minDateTimestamp',
        label: '最小可选时间戳',
        type: 'timestamp',
        props: {
            placeholder: '默认十年前',
        },
    },
    {
        key: 'maxDateOffset',
        label: '最大可选时间距离当前毫秒数',
        type: 'number',
        props: {
            controls: false,
            placeholder: '默认十年后',
        },
    },
    {
        key: 'maxDateTimestamp',
        label: '最大可选时间戳',
        type: 'timestamp',
        props: {
            placeholder: '默认十年后',
        },
    },
    {
        key: 'dateTips',
        label: '提示文案',
        type: 'string',
        props: {
            clearable: true,
            placeholder: '请输入',
        },
    },
    {
        key: 'confirmButtonText',
        label: '确认按钮',
        type: 'string',
    },
    {
        key: 'cancelButtonText',
        label: '取消按钮',
        type: 'string',
    },
    ...requiredProps,
    ...validatorProps,
    {
        key: 'ocrDateRangeValidator',
        label: 'OCR有效期校验',
        type: 'ocrDateRangeValidator',
        props: {},
    },
    {
        key: 'ocrConfig',
        label: 'ocr内容配置',
        type: 'ocrConfig',
        props: {},
    },
];

export const init = () => ({
    ...ablePropsInit,
    placeholder: '请选择',
    type: 'datetime',
    timeModeResetDate: false,
    title: '',
    minDateOffset: undefined,
    minDateTimestamp: undefined,
    maxDateOffset: undefined,
    maxDateTimestamp: undefined,
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    dateTips: '若为长期，请选择可选的最后日期',
    ...requiredPropsInit,
    ...validatorPropsInit,
});

export const name = '日期时间选择器';

export const component = 'mobile-general-form-datetime-picker';

export const events = [
    'user-input',
    'change',
    ...baseEvents,
];

